module.exports = __webpack_public_path__ + "img/adx.eaf4aaca.svg";